var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageheader",style:('background-image: '+ 'url('+_vm.background+');background-position:'+_vm.position+';')},[_c('div',{staticClass:"header-text"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('h3',[_vm._v(_vm._s(_vm.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }